import { Entity } from '@/store/shared/entity'

export default class IncomeDetail extends Entity<number>{
        //收汇记录标识
        incomeId:number;        
        //收款类型
        incomeType:string;        
        //实收金额
        amount:number;        
        //
        bankFee:number;        
        //币种
        currency:string; 
        currency_en:string;       
        //到账日期
        incomeDate:Date;        
        //备注
        remark:string;   
        
        editRowIndex:number;
        //本次需要填入的预付金
        prePaymentAmount:number;
        //本次需要填入的尾款
        restAmount:number;
        //是否预收款
        isAdvance:boolean;
}
